var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`section is-${_vm.size} has-text-centered empty is-fullheight`},[_vm._m(0),_c('p',{staticClass:"title is-5 has-text-danger"},[_vm._v(_vm._s(_vm.text))]),_c('p',{staticClass:"subtitle is-6 has-text-danger"},[_vm._v(_vm._s(_vm.subtext))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon is-large"},[_c('i',{staticClass:"fal fa-2x fa-eye-slash"})])
}]

export { render, staticRenderFns }